import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class ResourcesPeopleCreateRoute extends Route {
  @service store;

  model() {
    const person = this.store.createRecord('person');
    person.active = true;
    return person;
  }
}

export default instrumentRoutePerformance(ResourcesPeopleCreateRoute);
